var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLargeThumbnailsViewIcon = function SvgLargeThumbnailsViewIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2 12.6h6.6a.6.6 0 0 1 .6.6v7.5a.6.6 0 0 1-.6.6h-6.6a.6.6 0 0 1-.6-.6v-7.5a.6.6 0 0 1 .6-.6Zm-9 0h6.6a.6.6 0 0 1 .6.6v7.5a.6.6 0 0 1-.6.6H4.2a.6.6 0 0 1-.6-.6v-7.5a.6.6 0 0 1 .503-.592L4.2 12.6Zm9-9.9h6.6a.6.6 0 0 1 .6.6v7.5a.6.6 0 0 1-.6.6h-6.6a.6.6 0 0 1-.6-.6V3.3a.6.6 0 0 1 .6-.6Zm-9 0h6.6a.6.6 0 0 1 .6.6v7.5a.6.6 0 0 1-.6.6H4.2a.6.6 0 0 1-.6-.6V3.3a.6.6 0 0 1 .503-.592L4.2 2.7Z",
    fill: "currentColor",
    fillRule: "nonzero"
  }))));
};

export default SvgLargeThumbnailsViewIcon;